import { DatePicker, Form, Modal, notification } from 'antd'
import moment from 'moment'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { BlockTrainStatusEnum } from '../types'
import useUpdateBlocktrainStatus from '../hooks/blocktrain/useUpdateBlocktrainStatus'

interface BlocktrainModalProps {
  visible: boolean
  close: () => void
  onCancel?: () => void
}

const ConfirmFinishLoading: FC<BlocktrainModalProps> = ({ visible, close }) => {
  const { id } = useParams<{ id: string }>()
  const { t } = useTranslation()
  const { updateBlocktrainStatus, updateBlocktrainStatusIsFetching } = useUpdateBlocktrainStatus()

  const [form] = Form.useForm()

  const disabledDate = (current: any) => {
    return current && current < moment().startOf('day')
  }

  const onFinishLoadingConfirm = async () => {
    await form
      .validateFields()
      .then(values => {
        const { estimatedDateOfDeparture, estimatedTimeArrival } = values
        const payload = {
          id: id!,
          status: BlockTrainStatusEnum.WAITING_APPROVAL,
          estimatedDateOfDeparture,
          estimatedTimeArrival,
        }
        updateBlocktrainStatus(payload)
        close()
      })
      .catch(err => {
        notification.destroy('validationError')
        notification.error({
          message: t('globals.validation_error'),
          key: 'validationError',
        })
        console.error(err)
      })
  }

  return (
    <Modal
      title={t('confirm_finish_loading_blocktrain')}
      open={visible}
      onCancel={() => {
        close()
      }}
      className="entity-modal"
      okText={t('finish_loading')}
      cancelText={t('cancel')}
      onOk={onFinishLoadingConfirm}
      okButtonProps={{
        loading: updateBlocktrainStatusIsFetching,
      }}
    >
      <Form form={form} layout="horizontal" className="centered-form ant-form-item">
        <Form.Item
          label={t('etd')}
          name="estimatedDateOfDeparture"
          rules={[{ required: true, message: t('please_input_destination') }]}
        >
          <DatePicker placeholder={t('select_date')} disabledDate={disabledDate} />
        </Form.Item>
        <Form.Item
          label={t('eta')}
          name="estimatedTimeArrival"
          rules={[{ required: true, message: t('please_input_destination') }]}
        >
          <DatePicker placeholder={t('select_date')} disabledDate={disabledDate} />
        </Form.Item>
      </Form>

      <h3>{t('cannot_undone_advice')}</h3>
    </Modal>
  )
}

export default ConfirmFinishLoading
